import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../root/root-types';

export const TOUR_FEATURE_KEY = 'tourData';

export interface TourState {
  currentTooltipIndex: number;
  isTourActive: boolean;
}

export const initialTourState: TourState = {
  currentTooltipIndex: 0,
  isTourActive: false,
};

export const tourSlice = createSlice({
  name: TOUR_FEATURE_KEY,
  initialState: initialTourState,
  reducers: {
    updateCurrentTooltipIndex(state, action: PayloadAction<number>) {
      state.currentTooltipIndex = action.payload;
    },
    updateIsTourActive(state, action: PayloadAction<boolean>) {
      state.isTourActive = action.payload;
    },
  },
});

export const { updateCurrentTooltipIndex, updateIsTourActive } =
  tourSlice.actions;

export const getTourSliceState = (rootState: RootState): TourState =>
  rootState[TOUR_FEATURE_KEY];

export const getCurrentTooltipIndex = createSelector(
  getTourSliceState,
  (state) => state.currentTooltipIndex
);

export const getIsTourActive = createSelector(
  getTourSliceState,
  (state) => state.isTourActive
);
